import { EventEmitter } from '@angular/core';
import { ContactPermission } from '../../../../models/inbox';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { UserService } from '../../../services/user.service';
import { ChannelStatus, FacebookAuthPreviousState, platformIconPath } from '../../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../services/modal/modal.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { AuthService } from '../../../core/auth.service';
import { ActivatedRoute } from '@angular/router';
var ContactPermissionDetailComponent = /** @class */ (function () {
    function ContactPermissionDetailComponent(influencerService, userService, auth, activatedRoute, translate, modalService) {
        this.influencerService = influencerService;
        this.userService = userService;
        this.auth = auth;
        this.activatedRoute = activatedRoute;
        this.translate = translate;
        this.modalService = modalService;
        this.isDeletedOrError = false;
        this.openContactEvt = new EventEmitter();
        this.acceptCallback = new EventEmitter();
        this.declineCallback = new EventEmitter();
        this.showDeclineModal = false;
        this.listExistingChannel = [];
        this.isFbAuthFail = false;
    }
    ContactPermissionDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params.error) {
                _this.isFbAuthFail = true;
            }
        });
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            this.loadInfluencerChannels(currentInfluencer.id);
        }
        this.confirmInfluencerNameAndEmailSubscription = this.influencerService.confirmInfluencerNameAndEmailObserver
            .subscribe(function (res) {
            _this.isConfirmingInfluencerNameAndEmail = res;
        });
    };
    ContactPermissionDetailComponent.prototype.ngAfterViewInit = function () {
        var localChannelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
        if (localChannelAuthData) {
            this.modalService.openInCenter(this.ChannelConfirmPopup, null, 'campaign-confirm-popup');
            // remove the local auth data
            this.auth.removeInfluencerChannelAuthorizationLocalData();
        }
    };
    ContactPermissionDetailComponent.prototype.ngOnDestroy = function () {
        if (this.confirmInfluencerNameAndEmailSubscription) {
            this.confirmInfluencerNameAndEmailSubscription.unsubscribe();
        }
    };
    ContactPermissionDetailComponent.prototype.onDeclinePermission = function () {
        this.showDeclineModal = true;
    };
    ContactPermissionDetailComponent.prototype.onAcceptPermission = function () {
        var hasConfirmedAllChannels = this.listExistingChannel.length > 0
            && this.listExistingChannel.filter(function (cn) { return cn.type !== ChannelStatus.AUTHORIZED; }).length === 0;
        if (hasConfirmedAllChannels) {
            this.modalService.close();
            this.acceptCallback.emit(this.permissionToken);
        }
        else {
            this.modalService.openInCenter(this.ChannelConfirmPopup, null, 'campaign-confirm-popup');
        }
    };
    ContactPermissionDetailComponent.prototype.onConfirmChannel = function () {
        this.modalService.close();
        this.acceptCallback.emit(this.permissionToken);
    };
    ContactPermissionDetailComponent.prototype.acceptToDecline = function (evt) {
        this.showDeclineModal = false;
        this.declineCallback.emit(this.permissionToken);
    };
    ContactPermissionDetailComponent.prototype.openContact = function () {
        this.openContactEvt.emit();
    };
    ContactPermissionDetailComponent.prototype.closeDeclineModal = function () {
        this.showDeclineModal = false;
    };
    ContactPermissionDetailComponent.prototype.clickOutsideDeclineModal = function (evt) {
        if (!evt.target.classList.contains('decline-btn')) {
            this.closeDeclineModal();
        }
    };
    ContactPermissionDetailComponent.prototype.loadInfluencerChannels = function (influencerId) {
        var _this = this;
        this.influencerService.getInfluencerChannels(influencerId).subscribe(function (res) {
            _this.listExistingChannel = res;
            var igChannels = _this.listExistingChannel.filter(function (ec) { return ec.platform.id === platformIconPath.instagram.id; });
            if (igChannels.length > 0) {
                var channelAuthData_1 = _this.auth.getInfluencerChannelAuthorizationLocalData();
                igChannels.forEach(function (cn) {
                    if (channelAuthData_1 && cn.id === channelAuthData_1.activeChannelId && _this.isFbAuthFail) {
                        cn.type = ChannelStatus.AUTHORIZE_FAILED;
                    }
                    else if (!_this.auth.hasAuthorizedIgChannel(cn.id)) {
                        // force to influencer always to authorize the ig channel before accepting to get the updated auth token
                        cn.type = ChannelStatus.UNAUTHORIZE;
                    }
                });
            }
        });
    };
    Object.defineProperty(ContactPermissionDetailComponent.prototype, "acceptButtonLabel", {
        get: function () {
            if (!this.listExistingChannel) {
                return this.translate.instant('common.btn.continue');
            }
            if (this.listExistingChannel.length === 0
                || this.listExistingChannel.filter(function (cn) { return cn.type !== ChannelStatus.AUTHORIZED; }).length > 0) {
                return this.translate.instant('common.btn.continue');
            }
            else {
                return this.translate.instant('common.btn.accept');
            }
        },
        enumerable: true,
        configurable: true
    });
    ContactPermissionDetailComponent.prototype.closeNotification = function () {
        this.modalService.close();
    };
    Object.defineProperty(ContactPermissionDetailComponent.prototype, "activePageBeforeAuthorizingFb", {
        get: function () {
            return FacebookAuthPreviousState.ON_CONTACT_PERMISSION;
        },
        enumerable: true,
        configurable: true
    });
    return ContactPermissionDetailComponent;
}());
export { ContactPermissionDetailComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/contact-permission/contact-permission-detail/contact-permission-detail.component.ts.pre-build-optimizer.js